module.exports = __webpack_public_path__ + "static/media/browser-dashboard.b2814991.png";